import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=5e5dbbbc&scoped=true&lang=html"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&id=5e5dbbbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5dbbbc",
  null
  
)

export default component.exports